export interface ImageGenerationParams {
  baseURL: string;
  apiKey: string;
  model: string;
  responseFormat: string;
  width: number;
  height: number;
  numInferenceSteps: number;
  negativePrompt: string;
  seed: number;
  prompt: string;
  extra_body?: {
    response_extension: string;
    width: number;
    height: number;
    num_inference_steps: number;
    negative_prompt: string;
    seed: number;
  };
}

export interface ImageGenerationResponse {
  b64_json?: string;
  url?: string;
}

export async function generateImage(params: ImageGenerationParams): Promise<ImageGenerationResponse> {
  try {
    // Call our backend API instead of directly calling OpenAI
    const response = await fetch('/api/generate-image', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(params),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || `服务器响应状态码: ${response.status}`);
    }

    const data = await response.json();
    
    // 处理不同的响应格式
    if (params.responseFormat === 'b64_json') {
      if (!data.b64_json) {
        throw new Error("服务器返回无效响应");
      }
      return {
        b64_json: data.b64_json,
      };
    } else if (params.responseFormat === 'url') {
      if (!data.url) {
        throw new Error("服务器返回无效响应");
      }
      return {
        url: data.url,
      };
    } else {
      throw new Error(`不支持的响应格式: ${params.responseFormat}`);
    }
  } catch (error) {
    console.error("生成图像错误:", error);
    throw error;
  }
} 